/**
 * One-time purchase CTA handler.
 *
 * Adds the current product variant to cart as a ONE-TIME purchase (posts
 * id + quantity only, no selling_plan) regardless of the Recharge widget
 * selection, then refreshes the mini-cart using the theme's existing globals.
 *
 * Shares the in-flight guard, Adding…/Added ✓ button feedback and request
 * timeouts with the main PDP and sticky buttons via window.iwAtc
 * (assets/iw-atc-feedback.js, loaded in scripts_head).
 *
 * Wired via a delegated click listener on `.js-one-time-atc` (bottom of file).
 * Defined on window once; loading this asset more than once is harmless.
 */
window.addOneTimeToCart = window.addOneTimeToCart || function (btn) {
  var select = document.getElementById('product-select');
  var variantId = (select && select.value) || (btn && btn.getAttribute('data-variant-id'));
  if (!variantId) return;

  // A readOnly selector is one pdp-price-sync has locked to a Recharge tier's
  // unit count. That count belongs to the subscription, not to this one-time
  // add, so it starts from a single unit rather than inheriting the tier's.
  var qtyEl = document.querySelector('.js-quantity-selector');
  var qty = qtyEl && qtyEl.readOnly ? 1 : parseInt(qtyEl && qtyEl.value, 10);
  if (!qty || qty < 1) qty = 1;

  window.iwAtc.guardedAdd(btn, async function () {
    var result;
    try {
      result = await window.iwAtc.fetchJsonWithTimeout('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });
    } catch (netErr) {
      if (typeof showCartErrorMessage === 'function') showCartErrorMessage();
      throw netErr;
    }
    if (!result.response.ok || result.data.status) {
      if (typeof showCartErrorMessage === 'function') showCartErrorMessage();
      throw new Error('cart/add failed: ' + (result.data.status || result.response.status));
    }

    if (typeof getglobalLib === 'function' && getglobalLib('Mini_Cart') === 'yes') {
      try {
        var cart = (await window.iwAtc.fetchJsonWithTimeout('/cart.js')).data;
        if (typeof showCartSuccessMessage === 'function') showCartSuccessMessage();
        if (typeof progressBar === 'function') progressBar();
        if (typeof reloadAjaxCartItemUsingCartAjaxObject === 'function') {
          await reloadAjaxCartItemUsingCartAjaxObject(cart);
        }
      } catch (drawerErr) {
        console.warn('one-time ATC drawer refresh failed (item was added)', drawerErr);
      }
    } else {
      window.location = '/cart';
    }
  });
};

if (!window.iwOneTimeBound) {
  window.iwOneTimeBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-one-time-atc');
    if (!btn) return;
    e.preventDefault();
    window.addOneTimeToCart(btn);
  });
}
